import HoldOn from 'react-hold-on';
import Swal from 'sweetalert2';
import moment from 'moment';
import $ from 'jquery';
import colors from './colors';
import Constants from './constants';

class Globals {

	hold_on_present = false;

	setLoading = () => {
		if (!this.hold_on_present) {
			this.hold_on_present = true;
			HoldOn.open({
			     theme: "sk-bounce"
			});
		}
	}

	quitLoading = () => {
		HoldOn.close();
		setTimeout(() => {
			this.hold_on_present = false;
		},500);
	}

	generateS3 = (name: string, s3: number) => {
		if (s3 == Constants.S3.YES) {
			return `${ process.env.REACT_APP_CONTABO_BUCKET }${ name }`;
		}
		else {
			return Constants.BASE_STORAGE + name;
		}
	}

	zeroPad = (num: any) => {
	  return num.toString().padStart(6, "0");
	}

	formatMiles = (n: any, decimals: boolean = true, currency: string = '$',invertPoints = false) => {
		var c: any = isNaN(c = Math.abs(c)) ? 2 : c,
			d: any = d == undefined ? invertPoints ? "." : "," : d,
			t: any = t == undefined ? invertPoints ? "," : "." : t,
			s: any = n < 0 ? "-" : "",
			i: any = String(parseInt(n = Math.abs(Number(n) || 0).toFixed(c))),
			j: any = (j = i.length) > 3 ? j % 3 : 0;

		return currency + ' ' + s + (j ? i.substr(0, j) + t : "") + i.substr(j).replace(/(\d{3})(?=\d)/g, "$1" + t) + (c ? d + Math.abs(n - i).toFixed(c).slice(2) : "");
	}

	hideTooltip = () => {
		$('button').blur();
		$('a').blur();
    }

	showSuccess = (message: string) => {
		Swal.fire({
            title: "",
            text: message,
            type: "success",
			showCancelButton: false,
			confirmButtonColor: colors.swal,
			onClose: () => {
				this.hideTooltip()
			}
        });
	}

	showHtml = (message: string) => {
		Swal.fire({
            title: "",
            html: message,
            type: "warning",
			showCancelButton: false,
			confirmButtonColor: colors.swal,
			onClose: () => {
				this.hideTooltip()
			}
        });
	}

	showWarning = (message: string) => {
		Swal.fire({
            title: "",
            text: message,
            type: "warning",
			showCancelButton: false,
			confirmButtonColor: colors.swal,
			onClose: () => {
				this.hideTooltip()
			}
        });
	}

	showError = (message?: string) => {
		Swal.fire({
            title: "",
            text: message ? message : "Por favor, revise su conexión",
            type: "error",
			showCancelButton: false,
			confirmButtonColor: colors.swal,
			onClose: () => {
				this.hideTooltip()
			}
        });
	}

	confirm = (message: string,callback: any) => {
		this.hideTooltip();
		Swal.fire({
            title: "",
            text: message,
            type: "warning",
			showCancelButton: true,
            confirmButtonText: 'Aceptar',
			cancelButtonText: 'Cancelar',
			confirmButtonColor: colors.swal,
			onClose: () => {
				this.hideTooltip()
			}
        }).then((confirm: any) => {
        	if (confirm.value) {
        		callback();
        	}
        });
	}

	clone = (data: any) => {
		return JSON.parse(JSON.stringify(data));
	}

	getDate = (date: string, to: string = 'DD/MM/YYYY', from: string = 'YYYY-MM-DD HH:mm:ss') => {
		return moment(date,from).format(to);
	}

	capitalize = (text: string) => {
		return text.charAt(0).toUpperCase() + text.slice(1);
	}

	isPdf(file: string) {
		return file.substr(file.lastIndexOf('.') + 1) == 'pdf';
	}

	isImage(file: string) {
		const formats = ['png','jpg','jpeg'];
		return formats.indexOf(file.substr(file.lastIndexOf('.') + 1)) != -1;
	}

	formatPercentage(amount: number) {
		return amount.toFixed(2) + '%';
	}

	pad(num: number | string, size = 4) {
	    num = num.toString();
	    while (num.length < size) num = "0" + num;
	    return num;
	}

	calculateAge = (dateString: string) => {
	    var today = new Date();
	    var birthDate = new Date(dateString);
	    var age = today.getFullYear() - birthDate.getFullYear();
	    var m = today.getMonth() - birthDate.getMonth();
	    if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
	        age--;
	    }
	    return age;
	}

	clean = (cadena: string) => {
	   var specialChars = "!@#$^&%*()+=-[]\/{}|:<>?,.";
	   for (var i = 0; i < specialChars.length; i++) {
	       cadena= cadena.replace(new RegExp("\\" + specialChars[i], 'gi'), '');
	   }
	   cadena = cadena.toLowerCase();
	   cadena = cadena.replace(/ /g,"_");
	   cadena = cadena.replace(/á/gi,"a");
	   cadena = cadena.replace(/é/gi,"e");
	   cadena = cadena.replace(/í/gi,"i");
	   cadena = cadena.replace(/ó/gi,"o");
	   cadena = cadena.replace(/ú/gi,"u");
	   cadena = cadena.replace(/ñ/gi,"n");
	   return cadena;
  	}
}

export default new Globals();